enum ACTIONS {
    FETCH_ENTITY_TYPES = '[FETCH] - ENTITY TYPES',
    PATCH_ENTITY_TYPES = '[PATCH] - ENTITY TYPES'
}

export default ACTIONS;